module.exports = __webpack_public_path__ + "img/icon-remove.82e997c8.svg";